module.exports = __webpack_public_path__ + "img/technology-split-image-02.87307888.svg";